import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function Footer() {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const handleModalOpen = () => setIsHidden(true);
    const handleModalClose = () => setIsHidden(false);

    window.addEventListener('modalOpen', handleModalOpen);
    window.addEventListener('modalClose', handleModalClose);

    return () => {
      window.removeEventListener('modalOpen', handleModalOpen);
      window.removeEventListener('modalClose', handleModalClose);
    };
  }, []);

  return (
    <footer className={`relative z-[5] bg-black/40 backdrop-blur-md border-t border-red-500/20 ${isHidden ? 'hidden' : ''}`}>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img src="https://res.cloudinary.com/dvq5iv4qs/image/upload/v1760482265/-ct_logo_light_copy_cxvyoy.png" alt="Cybertronic Logo" className="h-12" />
              <h3 className="text-2xl font-bold text-[#EE1C23]">CYBERTRONIC</h3>
            </div>
            <p className="text-gray-400 mb-4">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">{t('footer.contact')}</h4>
            <div className="space-y-2 text-gray-400">
              <p><span className="text-[#EE1C23]">{t('footer.email')}:</span> cybertronic@email.cz</p>
              <p><span className="text-[#EE1C23]">{t('footer.phone')}:</span> +420 777 875 098</p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Social</h4>
            <div className="space-y-2">
              <a href="https://www.tiktok.com/@reno_cybertronic" target="_blank" rel="noopener noreferrer" className="block text-gray-400 hover:text-[#EE1C23] transition-colors">TikTok</a>
              <a href="https://www.instagram.com/reno_all4life/" target="_blank" rel="noopener noreferrer" className="block text-gray-400 hover:text-[#EE1C23] transition-colors">Instagram</a>
              <a href="https://www.facebook.com/cybertronic.unlimited" target="_blank" rel="noopener noreferrer" className="block text-gray-400 hover:text-[#EE1C23] transition-colors">Facebook</a>
              <a href="https://www.herohero.co/cybertronic" target="_blank" rel="noopener noreferrer" className="block text-gray-400 hover:text-[#EE1C23] transition-colors">HeroHero</a>
            </div>
          </div>

          <div className="md:-ml-[25%]">
            <h4 className="text-lg font-semibold text-white mb-4">{t('footer.websiteBy')}</h4>
            <a href="https://digitalshrooms.cz/" target="_blank" rel="noopener noreferrer" className="block group">
              <img src="/digitalshrooms-logo.png" alt="Digital Shrooms Logo" className="h-[4.375rem] transition-all duration-500 ease-out group-hover:scale-110" />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800">
          <p className="text-center text-gray-500">
            © 2026 Cybertronic. {t('footer.rights')}.
          </p>
        </div>
      </div>
    </footer>
  );
}